"use strict";
function Tuneup($scope, $timeout, $state) {

    const ctrl = this;

    ctrl.$onInit = function () {
        $scope.data = "Search for account id";
        $scope.accountId = ""
    };

    $scope.fetchAccountJson = function (accountId) {
        $scope.data = "Fetching account json...";
        $scope.accountId = accountId;
        store.fetch({
            method: "GET",
            url: "/tuneup/getAccountJson",
            queryParams: {
                accountId: accountId
            },
            success: function success(data) {
                $scope.data = JSON.stringify(data,null,4);
            },
            error: function error() {
                $scope.data = null;
                $scope.error = `Something went wrong while trying to fetch account(${accountId})`;
            }
        });
    }
}